import UserPanelTitle from './UserPanelTitle'

export default UserPanelTitle
